// Menyn i kontot, i designens ordning. Uppföljningen saknas i designen och
// står efter Utskick (ADR 0072). Användare står näst sist (ADR 0083), och
// Abonnemang efter Användare (ADR 0120), och Resurser, hjälpen för byrån,
// sist (ADR 0105).
import { ikoner } from './ikoner.js';

export interface Menyval {
  till: string;
  etikett: string;
  ikon: keyof typeof ikoner;
}

export const MENY: Menyval[] = [
  { till: '/', etikett: 'Inkorg', ikon: 'inkorg' },
  { till: '/katalog', etikett: 'Tjänstekatalog', ikon: 'katalog' },
  { till: '/testlage', etikett: 'Testläge', ikon: 'testlage' },
  { till: '/offertmall', etikett: 'Offertmall', ikon: 'offertmall' },
  { till: '/utskick', etikett: 'Utskick', ikon: 'utskick' },
  { till: '/uppfoljning', etikett: 'Uppföljning', ikon: 'uppfoljning' },
  { till: '/formular', etikett: 'Formulär', ikon: 'formular' },
  { till: '/anvandare', etikett: 'Användare', ikon: 'anvandare' },
  { till: '/abonnemang', etikett: 'Abonnemang', ikon: 'abonnemang' },
  { till: '/resurser', etikett: 'Resurser', ikon: 'resurser' },
];
